import { AppAntSwitch } from "@components";
import React from "react";
import {tableHideDetails} from "../../../@signals";

export default function ToggleTableDetails() {

    return <AppAntSwitch
        checked={tableHideDetails.value}
        onChange={() => tableHideDetails.value = !tableHideDetails.value}
        stackProps={{ direction: 'column' }} falseText="Hide Details"
    />
}